module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-CartridgeCase-72dpi.448dfdfd.jpg";